import React, { Fragment, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Modal,
  Button,
  Dropdown,
  Table,
} from "react-bootstrap";

import { db } from "../../../firebase";
import Toast from "../toast/SetToast";
import { functions } from "../../../firebase";
import { httpsCallable } from "firebase/functions";

import {
  query,
  endAt,
  getDocs,
  collection,
  orderBy,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  startAt,
  getCountFromServer,
  where,
  doc,
  deleteDoc,
  updateDoc,
  setDoc,
  runTransaction,
  collectionGroup,
} from "firebase/firestore";
import { notifyError, notifyTopRight } from "../toast/SetToast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import { mergeBookingExtendedPropsWithAutomationState } from "./BookingAutomationStateUtils";
import { assertNodeAcceptsNewBooking } from "../../../utils/nodeBookingAvailability";
import { normalizeBookingAdditionalEquipment } from "./BookingAdditionalEquipment";
import { getBookingExtendedPropsForSave } from "./BookingEventUtils";

const nodeList = ["BD"];
const typeList = [
  "Full Night Sleep Study",
  "Split Night Sleep Study",
  "CPAP Titration",
  "Home Full Night Sleep Study",
  "Overnight Pulse Oximetry Study",
  "Multiple Sleep Latency Test",
  // "MSLT",
  // "MWT",
];

const statusList = [
  "Sleep Test Scheduled",
  "Reserve Sleep Set",
  "Transferred To Center",
  "Assigned",
  "Technician Scored",
  "Assigned to Doctor",
  "Doctor Scored",
  "Post-Consult",
  "Sale Follow Up",
  "Sale Follow Up [MC]", // Medical Certificate for LPH (Normally, the medical certificate is included with the report as a separate file)
  "Sale Follow Up [STM]", // Statement for CHG
  "Ready for CPAP Purchase",
  "Ship",
  "Ship [CPAP Purchase]",
  "Ship [CPAP Trial]",
  "Ship [CPAP Rental]",
  "Ship [No CPAP]",
  "Cancel",
  "Failure",
];

const statusOrder = {
  "Sleep Test Scheduled": 1,
  "Reserve Sleep Set": 2,
  "Transferred To Center": 3,
  Assigned: 4,
  "Technician Scored": 5,
  "Assigned to Doctor": 6,
  "Doctor Scored": 7,
  "Post-Consult": 8,
  "Sale Follow Up": 9,
  "Sale Follow Up [MC]": 10,
  "Sale Follow Up [STM]": 11,
  "Ready for CPAP Purchase": 12,
  Ship: 13,
  "Ship [CPAP Purchase]": 14,
  "Ship [CPAP Trial]": 15,
  "Ship [CPAP Rental]": 16,
  "Ship [No CPAP]": 17,
  Cancel: 18,
  Failure: 19,
};

const colorList = [
  "#005DEA",
  "#9379C2",
  // brgiht blue
  "#fab2a2",
  "#40C4FF",
  "#00CEAB",
  // light blue
  "#9ef542",
  "#711685",
  //  primary color
  "#F4B400",
  //  post consult yellow | Google yellow
  "#FF99CC",
  "#FF99CC",
  "#FF99CC",
  "#ff6f00",
  "#64a338",
  "#64a338",
  "#64a338",
  "#64a338",
  "#64a338",
  // ship green
  "#a8a8a8",
  // cancel gray
  "#dd0102",
  // failure red
];

const orderList = ["R1", "R2", "R3", "R4", "R5", "จองคิว"];

const paymentPrivilages = [
  "กรุณาเลือก",
  "ชำระเงินเอง",
  "ประกันสุขภาพถ้วนหน้า",
  "ประกันสังคม",
  "กรมบัญชีกลาง",
  "กรุงเทพมหานคร",
  "ต้นสังกัด",
  "นักศึกษา มธ.",
  "โครงการวิจัยรับค่าบริการล่วงหน้า",
  "องค์การปกครองส่วนท้องถิ่น",
  "โครงการตรวจสุขภาพรับค่าบริการล่วงหน้า",
  "ผ่อนชำระ/นิติกร",
  "อุบัติเหตุและฉุกเฉินนอกโรงพยาบาล(EMS)",
  "ปลัดกระทรวงสาธารณะสุข",
  "โครงการ 85 ปี",
  "อื่นๆ",
];

const eventTmp = {
  title: "",
  start: "",
  id: "",
  extendedProps: {
    order: "",
    hn: "",
    type: "",
    additionalEquipment: [],
    status: "",
    firstname: "",
    lastname: "",
    nationalId: "",
    healthInsurance: "กรุณาเลือก",
    phone: "",
    note: "",
    node: "",
    customer: "",
    sale: "",
    items: [],
    totalValue: 0,
    time: "",
    technician: "",
    doctor: "",
  },
};

export const sendNotification = httpsCallable(functions, "sendNotification");
const completeBookingNodeMove = httpsCallable(functions, "completeBookingNodeMove");

export const PatientDropDownForm = ({
  title = "",
  htmlFor = "",
  id = "",
  name = "",
  refvalue,
  placeholder = "Please select",
  selected = "",
  options = [""],
  onChange,
  disabled,
  isBold = false,
}) => {
  return (
    <div className="form-group row">
      {isBold ? (
        <b className="col-lg-3 col-form-label" htmlFor={htmlFor}>
          {title}
          <span className="text-danger">*</span>
        </b>
      ) : (
        <label className="col-lg-3 col-form-label" htmlFor={htmlFor}>
          {title}
          <span className="text-danger"></span>
        </label>
      )}
      <div className="col-lg-5">
        {["techrecord", "techscore"].includes(id) ? (
          <select
            className="form-control"
            id={id}
            name={name}
            ref={refvalue}
            onChange={onChange}
            disabled={disabled}
          >
            {options.map((value) => (
              <option
                value={value.name}
                selected={selected == value.name ? "selected" : ""}
              >
                {value.name} ({value.nickname})
              </option>
            ))}
          </select>
        ) : (
          <select
            className="form-control"
            id={id}
            name={name}
            ref={refvalue}
            onChange={onChange}
            disabled={disabled}
          >
            {options.map((value) => (
              <option
                value={value}
                selected={selected == value ? "selected" : ""}
              >
                {value}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export const PatientCheckboxForm = ({
  title = "",
  options = [""],
  name = "",
  defaultCheckedValues = [],
  mt = "row mt-3",
  refValue, // Pass the ref for managing state
}) => {
  return (
    <fieldset className="form-group">
      <div className={mt}>
        <label className="col-xl-3 col-form-label pt-0">{title}</label>
        <div className="col-xl-5">
          {options.map((value, index) => (
            <div className="form-check" key={index}>
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name={name}
                  value={value}
                  defaultChecked={defaultCheckedValues.includes(value)} // Pre-check based on default values
                  onChange={(e) => {
                    if (e.target.checked) {
                      refValue.current = value; // Update ref when checked
                    } else {
                      refValue.current = ""; // Clear ref when unchecked
                    }
                    console.log("Checked value:", refValue.current); // Debug log
                  }}
                />
                {value}
              </label>
            </div>
          ))}
        </div>
      </div>
    </fieldset>
  );
};

export const PatientCheckboxFormState = ({
  title = "",
  options = [""],
  name = "",
  selectedFilter, // Receive state from parent
  setSelectedFilter, // Receive state updater from parent
  mt = "row mt-3",
}) => {
  return (
    <fieldset className="form-group">
      <div className={mt}>
        <label className="col-xl-3 col-form-label pt-0">{title}</label>
        <div className="col-xl-5">
          {options.map((value, index) => (
            <div className="form-check" key={index}>
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name={name}
                  value={value}
                  checked={selectedFilter === value} // Ensure only one is selected
                  onChange={() => setSelectedFilter(value)} // Update state
                />
                {value}
              </label>
            </div>
          ))}
        </div>
      </div>
    </fieldset>
  );
};

export const PatientTextInfo = ({
  title = "",
  value = "",
  bold = false,
  titleBold = false,
  compactHeader = false,
}) => {
  const titleClassName = compactHeader
    ? "col-lg-2 col-form-label pr-lg-2"
    : "col-lg-3 col-form-label";
  const valueClassName = compactHeader
    ? "col-lg-10 pl-lg-2"
    : "col-lg-9";

  return (
    <div className={`form-group row${compactHeader ? " mb-2" : ""}`}>
      {titleBold ? (
        <b className={titleClassName} htmlFor="val-username">
          {title}
          <span className="text-danger">*</span>
        </b>
      ) : (
        <label className={titleClassName} htmlFor="val-username">
          {title}
        </label>
      )}
      <div className={valueClassName}>
        {bold ? (
          <>
            <b>{value}</b>
          </>
        ) : (
          <>
            <text>{value}</text>
          </>
        )}
      </div>
    </div>
  );
};
export const PatientLinkInfo = ({
  title = "",
  value = "",
  bold = false,
  path,
}) => {
  return (
    <div className="form-group row">
      <label className="col-lg-3 col-form-label" htmlFor="val-username">
        {title}
      </label>
      <div className="col-lg-8">
        {bold ? (
          <>
            <Link to={path}>
              <b>{value}</b>
            </Link>
          </>
        ) : (
          <>
            <Link to={path}>
              <text>{value}</text>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

const setEvent = async (
  eventAdd,
  oldEvent = undefined,
  nodeIdDocs,
  nodeNameDocs,
  currentUser = null,
) => {
  if (oldEvent == undefined) {
    oldEvent = eventAdd;
  } else {
    console.log("oldEvent not undefined");
  }
  console.log("eventAdd.start", eventAdd.start);
  console.log("eventAdd", eventAdd);
  try {
    const isNodeMove =
      oldEvent &&
      oldEvent.extendedProps &&
      eventAdd.extendedProps &&
      eventAdd.extendedProps.uuid &&
      eventAdd.extendedProps.node != oldEvent.extendedProps.node;
    const roles =
      currentUser && Array.isArray(currentUser.roles)
        ? currentUser.roles
        : [];

    if (
      isNodeMove &&
      !roles.some((role) => ["super_admin", "admin"].includes(role))
    ) {
      notifyError("Only super_admin and admin can move a booking to another node.");
      return "Err";
    }

    // Existing bookings can be changed through the table helper as well as
    // the calendar. Preserve the creator and record the latest operator for
    // the activity trigger.
    const bookingUpdateActor =
      currentUser && (currentUser.displayName || currentUser.email);
    if (bookingUpdateActor && eventAdd.extendedProps.uuid) {
      eventAdd.extendedProps.updatedBy = bookingUpdateActor;
      eventAdd.extendedProps.updatedAt = new Date();
    }

    if (
      eventAdd.extendedProps.uuid == undefined ||
      eventAdd.extendedProps.uuid == null ||
      eventAdd.extendedProps.node != oldEvent.extendedProps.node
    ) {
      const nodeIndex = nodeNameDocs.indexOf(eventAdd.extendedProps.node);
      const nodeId = nodeIdDocs[nodeIndex];
      await assertNodeAcceptsNewBooking(nodeId);
      const ref = doc(collection(db, "nodes", nodeId, "bookings"));
      await setDoc(ref, {
        title: eventAdd.title,
        id: eventAdd.id,
        start: new Date(eventAdd.start),
        end: eventAdd.end,
        color: eventAdd.color,
        extendedProps: {
          ...getBookingExtendedPropsForSave(eventAdd.extendedProps),
          order: eventAdd.extendedProps.order,
          hn: eventAdd.extendedProps.hn,
          type: eventAdd.extendedProps.type,
          status: eventAdd.extendedProps.status,
          firstname: eventAdd.extendedProps.firstname,
          lastname: eventAdd.extendedProps.lastname,
          nationalId: eventAdd.extendedProps.nationalId
            ? eventAdd.extendedProps.nationalId
            : "",
          healthInsurance: eventAdd.extendedProps.healthInsurance,
          phone: eventAdd.extendedProps.phone,
          node: eventAdd.extendedProps.node,
          customer: eventAdd.extendedProps.customer,
          sale: eventAdd.extendedProps.sale || "",
          note: eventAdd.extendedProps.note,
          items: eventAdd.extendedProps.items,
          totalValue: eventAdd.extendedProps.totalValue,
          time: eventAdd.extendedProps.time,
          doctor: eventAdd.extendedProps.doctor,
          technician: eventAdd.extendedProps.technician,
          techrecord: eventAdd.extendedProps.techrecord,
          techConsult: eventAdd.extendedProps.techConsult,
          referDoctor: eventAdd.extendedProps.referDoctor,
          postDoctor: eventAdd.extendedProps.postDoctor,

          latestSleepStudyDate: eventAdd.extendedProps.latestSleepStudyDate,
          ahi: eventAdd.extendedProps.ahi,
          additionalEquipment: normalizeBookingAdditionalEquipment(eventAdd.extendedProps.additionalEquipment),
          hospitalNumber: eventAdd.extendedProps.hospitalNumber,
          createBy: eventAdd.extendedProps.createBy
            ? eventAdd.extendedProps.createBy
            : "",
          gender: eventAdd.extendedProps.gender
            ? eventAdd.extendedProps.gender
            : "",
        },
      });
      eventAdd.extendedProps.uuid = ref.id;
      const refUpdate = doc(
        db,
        "nodes",
        nodeId,
        "bookings",
        eventAdd.extendedProps.uuid,
      );

      await updateDoc(refUpdate, {
        title: eventAdd.title,
        id: eventAdd.id,
        start: new Date(eventAdd.start),
        color: eventAdd.color,
        extendedProps: {
          ...getBookingExtendedPropsForSave(eventAdd.extendedProps),
          order: eventAdd.extendedProps.order,
          hn: eventAdd.extendedProps.hn,
          type: eventAdd.extendedProps.type,
          status: eventAdd.extendedProps.status,
          uuid: eventAdd.extendedProps.uuid,
          firstname: eventAdd.extendedProps.firstname,
          lastname: eventAdd.extendedProps.lastname,
          nationalId: eventAdd.extendedProps.nationalId
            ? eventAdd.extendedProps.nationalId
            : "",
          healthInsurance: eventAdd.extendedProps.healthInsurance,
          phone: eventAdd.extendedProps.phone,
          node: eventAdd.extendedProps.node,
          customer: eventAdd.extendedProps.customer,
          sale: eventAdd.extendedProps.sale || "",
          note: eventAdd.extendedProps.note,
          items: eventAdd.extendedProps.items,
          totalValue: eventAdd.extendedProps.totalValue,
          time: eventAdd.extendedProps.time,
          doctor: eventAdd.extendedProps.doctor,
          technician: eventAdd.extendedProps.technician,
          techrecord: eventAdd.extendedProps.techrecord,
          referDoctor: eventAdd.extendedProps.referDoctor,
          postDoctor: eventAdd.extendedProps.postDoctor,
          latestSleepStudyDate: eventAdd.extendedProps.latestSleepStudyDate,
          ahi: eventAdd.extendedProps.ahi,
          additionalEquipment: normalizeBookingAdditionalEquipment(eventAdd.extendedProps.additionalEquipment),
          hospitalNumber: eventAdd.extendedProps.hospitalNumber,
          createBy: eventAdd.extendedProps.createBy
            ? eventAdd.extendedProps.createBy
            : "",
          gender: eventAdd.extendedProps.gender
            ? eventAdd.extendedProps.gender
            : "",
        },
      });
      if (
        eventAdd.extendedProps.status == "Sleep Test Scheduled" ||
        eventAdd.extendedProps.status == "Cancel" ||
        eventAdd.extendedProps.status == "Technician Scored"
      ) {
        // setNotifyTech(eventAdd);
      }
      if (eventAdd.extendedProps.node != oldEvent.extendedProps.node) {
        const nodeIndexOld = nodeNameDocs.indexOf(oldEvent.extendedProps.node);
        const nodeIdOld = nodeIdDocs[nodeIndexOld];

        if (!nodeIdOld || !oldEvent.extendedProps.uuid) {
          throw new Error(
            "Cannot complete booking node move because the original booking record is missing.",
          );
        }

        await completeBookingNodeMove({
          sourceNodeId: nodeIdOld,
          sourceBookingId: oldEvent.extendedProps.uuid,
          destinationNodeId: nodeId,
          destinationBookingId: eventAdd.extendedProps.uuid,
        });
        console.log("booking moved from old node through protected workflow");

        // notify doctor and tech
        if (
          eventAdd.extendedProps.status == "Sleep Test Scheduled" ||
          eventAdd.extendedProps.status == "Cancel" ||
          eventAdd.extendedProps.status == "Technician Scored"
        ) {
          // setNotifyTech(eventAdd);
        }
        if (
          eventAdd.extendedProps.status == "Technician Scored" ||
          eventAdd.extendedProps.status == "Doctor Scored"
        ) {
          setNotifyDoctor(eventAdd);
        }
      }
    } else {
      const nodeIndex = nodeNameDocs.indexOf(eventAdd.extendedProps.node);
      const nodeId = nodeIdDocs[nodeIndex];
      const refUpdate = doc(
        db,
        "nodes",
        nodeId,
        "bookings",
        eventAdd.extendedProps.uuid,
      );
      await runTransaction(db, async (transaction) => {
        const docSnap = await transaction.get(refUpdate);
        const latestExtendedProps = docSnap.exists()
          ? docSnap.data().extendedProps || {}
          : {};

        transaction.update(refUpdate, {
        title: eventAdd.title,
        id: eventAdd.id,
        start: new Date(eventAdd.start),
        color: eventAdd.color,
        extendedProps: {
          ...getBookingExtendedPropsForSave(mergeBookingExtendedPropsWithAutomationState(
            eventAdd.extendedProps,
            latestExtendedProps,
          )),
          order: eventAdd.extendedProps.order,
          hn: eventAdd.extendedProps.hn,
          type: eventAdd.extendedProps.type,
          status: eventAdd.extendedProps.status,
          uuid: eventAdd.extendedProps.uuid,
          firstname: eventAdd.extendedProps.firstname,
          lastname: eventAdd.extendedProps.lastname,
          nationalId: eventAdd.extendedProps.nationalId
            ? eventAdd.extendedProps.nationalId
            : "",
          healthInsurance: eventAdd.extendedProps.healthInsurance,
          phone: eventAdd.extendedProps.phone,
          node: eventAdd.extendedProps.node,
          customer: eventAdd.extendedProps.customer,
          sale: eventAdd.extendedProps.sale || "",
          note: eventAdd.extendedProps.note,
          items: eventAdd.extendedProps.items,
          totalValue: eventAdd.extendedProps.totalValue,
          time: eventAdd.extendedProps.time,
          doctor: eventAdd.extendedProps.doctor,
          technician: eventAdd.extendedProps.technician,
          techrecord: eventAdd.extendedProps.techrecord,
          referDoctor: eventAdd.extendedProps.referDoctor,
          postDoctor: eventAdd.extendedProps.postDoctor,

          latestSleepStudyDate:
            eventAdd.extendedProps.latestSleepStudyDate !== undefined
              ? eventAdd.extendedProps.latestSleepStudyDate
              : latestExtendedProps.latestSleepStudyDate,
          ahi: eventAdd.extendedProps.ahi,
          additionalEquipment: normalizeBookingAdditionalEquipment(eventAdd.extendedProps.additionalEquipment),
          hospitalNumber: eventAdd.extendedProps.hospitalNumber,
          createBy: eventAdd.extendedProps.createBy
            ? eventAdd.extendedProps.createBy
            : "",
          gender: eventAdd.extendedProps.gender
            ? eventAdd.extendedProps.gender
            : "",
        },
        });
      });
      if (
        eventAdd.extendedProps.status == "Sleep Test Scheduled" ||
        eventAdd.extendedProps.status == "Cancel" ||
        eventAdd.extendedProps.status == "Technician Scored"
      ) {
        // setNotifyTech(eventAdd);
      }
      if (
        eventAdd.extendedProps.status == "Technician Scored" ||
        eventAdd.extendedProps.status == "Doctor Scored"
      ) {
        setNotifyDoctor(eventAdd);
      }
    }
    notifyTopRight("Update booking success !");
    return "OK";
  } catch (err) {
    console.log(err);
    notifyError(["node-unavailable", "technician-check-doctor-copy"].includes(err.code) ? err.message : "Unable to save booking. Please check the information and try again.");
    return "Err";
  }
};

const setNotifyDoctor = async (event) => {
  const sleepstudyInfo = {
    title: event.title,
    date: event.startDate,
    status: event.extendedProps.status,
    type: event.extendedProps.type,
    firstname: event.extendedProps.firstname,
    lastname: event.extendedProps.lastname,
    doctor: event.extendedProps.doctor,
    note: event.extendedProps.note,
    node: event.extendedProps.node,
    latestSleepStudyDate: event.extendedProps.latestSleepStudyDate,
  };
  const statusToCheck = sleepstudyInfo.status;
  const titleToCheck = sleepstudyInfo.title;
  const currentDoctorId = sleepstudyInfo.doctor; // Assuming this contains the current doctor's ID

  // Create a collection group query to find sleep study cases with the same title
  const matchingTitlesQuery = query(
    collectionGroup(db, "sleepStudyCases"),
    where("title", "==", titleToCheck),
  );
  const querySnapshot = await getDocs(matchingTitlesQuery);
  if (statusToCheck == "Doctor Scored") {
    if (querySnapshot.empty) {
      console.log("no matching documents found !");
    } else {
      for (const doc of querySnapshot.docs) {
        // Delete the document
        await deleteDoc(doc.ref);
        console.log(`Deleted sleep study case with title "${titleToCheck}" `);
      }
    }
  } else if (statusToCheck == "Technician Scored") {
    if (querySnapshot.empty) {
      console.log("no matching documents found !");
    } else {
      for (const doc of querySnapshot.docs) {
        // Check if the document is under a different doctor
        const docDoctorId = doc.ref.path.split("/")[1]; // Extracting doctor ID from the document reference path
        if (docDoctorId !== currentDoctorId) {
          // Delete the document
          await deleteDoc(doc.ref);
          console.log(
            `Deleted sleep study case with title "${titleToCheck}" under a different doctor (ID: ${docDoctorId}).`,
          );
        }
      }
    }
    const DoctorsQuery = query(
      collection(db, "doctors"),
      where("name", "==", sleepstudyInfo.doctor),
    );
    const DoctorDocuments = await getDocs(DoctorsQuery);
    var DoctorList = [];
    DoctorDocuments.forEach(async (document) => {
      const doctorId = document.id;
      const doctorInfo = document.data();

      const sleepStudyCasesCollectionRef = doc(
        collection(db, `doctors/${doctorId}/sleepStudyCases`),
      );
      await setDoc(sleepStudyCasesCollectionRef, sleepstudyInfo);
      const message = `\n${sleepstudyInfo.title} : ${sleepstudyInfo.firstname} ${sleepstudyInfo.lastname} \nStudy Date : ${sleepstudyInfo.latestSleepStudyDate} \n${sleepstudyInfo.type} \n${sleepstudyInfo.status}`;
      const accessToken = doctorInfo.accessToken;
      if (querySnapshot.empty) {
        sendNotification({ accessToken, message });
      }
    });
  }
};

const setNotifyTech = async (event) => {
  const sleepstudyInfo = {
    title: event.title,
    date: event.start,
    status: event.extendedProps.status,
    type: event.extendedProps.type,
    firstname: event.extendedProps.firstname,
    lastname: event.extendedProps.lastname,
    techrecord: event.extendedProps.techrecord,
    note: event.extendedProps.note,
    node: event.extendedProps.node,
    customer: event.extendedProps.customer,
    healthInsurance: event.extendedProps.healthInsurance,
    phone: event.extendedProps.phone,
  };
  const statusToCheck = sleepstudyInfo.status;
  const titleToCheck = sleepstudyInfo.title;
  const currentTechId = sleepstudyInfo.techrecord; // Assuming this contains the current doctor's ID

  // Create a collection group query to find sleep study cases with the same title
  const matchingTitlesQuery = query(
    collectionGroup(db, "sleepStudyCases"),
    where("title", "==", titleToCheck),
  );
  const querySnapshot = await getDocs(matchingTitlesQuery);
  if (statusToCheck == "Technician Scored") {
    if (querySnapshot.empty) {
      console.log("no matching documents found !");
    } else {
      for (const doc of querySnapshot.docs) {
        // Delete the document
        await deleteDoc(doc.ref);
        console.log(`Deleted sleep study case with title "${titleToCheck}" `);
      }
    }
  } else if (statusToCheck == "Sleep Test Scheduled") {
    if (querySnapshot.empty) {
      console.log("no matching documents found !");
    } else {
      for (const doc of querySnapshot.docs) {
        // Check if the document is under a different doctor
        const docTechId = doc.ref.path.split("/")[1]; // Extracting doctor ID from the document reference path
        if (docTechId !== currentTechId) {
          // Delete the document
          await deleteDoc(doc.ref);
          console.log(
            `Deleted sleep study case with title "${titleToCheck}" under a different doctor (ID: ${docTechId}).`,
          );
        }
      }
    }
    const TechQuery = query(
      collection(db, "sleeptechnicians"),
      where("name", "==", sleepstudyInfo.techrecord),
    );
    const TechDocuments = await getDocs(TechQuery);
    var TechList = [];
    TechDocuments.forEach(async (document) => {
      const techId = document.id;
      const techInfo = document.data();

      const sleepStudyCasesCollectionRef = doc(
        collection(db, `sleeptechnicians/${techId}/sleepStudyCases`),
      );
      await setDoc(sleepStudyCasesCollectionRef, sleepstudyInfo);
      const message = `\nเคสตรวจการนอนหลับที่ ${sleepstudyInfo.customer} \nStudy Date: ${sleepstudyInfo.date}\nSleep Technician: ${sleepstudyInfo.techrecord}
       \n${sleepstudyInfo.title}: ${sleepstudyInfo.firstname} ${sleepstudyInfo.lastname} \nTel: ${sleepstudyInfo.phone} \nHealth Insurance: ${sleepstudyInfo.healthInsurance} \n${sleepstudyInfo.type} \n${sleepstudyInfo.status}`;
      const accessToken = techInfo.accessToken;
      if (querySnapshot.empty) {
        sendNotification({ accessToken, message });
      }
    });
  } else if (statusToCheck == "Cancel") {
    for (const doc of querySnapshot.docs) {
      // Delete the document
      await deleteDoc(doc.ref);
      console.log(`Deleted sleep study case with title "${titleToCheck}" `);
    }
    const TechQuery = query(
      collection(db, "sleeptechnicians"),
      where("name", "==", sleepstudyInfo.techrecord),
    );
    const TechDocuments = await getDocs(TechQuery);
    TechDocuments.forEach(async (document) => {
      const techInfo = document.data();
      const accessToken = techInfo.accessToken;
      const message =
        "Cancel เคสตรวจการนอนหลับที่ " +
        sleepstudyInfo.customer +
        "\nวันที่ " +
        sleepstudyInfo.date +
        "\n" +
        sleepstudyInfo.title +
        ": " +
        sleepstudyInfo.firstname +
        " " +
        sleepstudyInfo.lastname;
      sendNotification({ accessToken, message });
    });
  }
};

export {
  setEvent,
  eventTmp,
  paymentPrivilages,
  orderList,
  colorList,
  statusList,
  typeList,
  nodeList,
  statusOrder,
};
